/**
 * @fileoverview GET handler for the "/engagement/prediction_app_group_data" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementPredictionAppGroupData } from "./constants";
import type { EngagementPredictionAppGroupDataResult } from "./types";

export const getEngagementPredictionAppGroupData = reactQueryFetcherAdapter(
  engagementPredictionAppGroupData,
  (signal: AbortSignal, appGroupId: string): Promise<EngagementPredictionAppGroupDataResult> => {
    return fetch("/engagement/prediction_app_group_data", "GET", { app_group_id: appGroupId }, { signal });
  }
);
